import {
	mapGetters,
	mapState,
	mapActions
} from 'vuex';

import {
	state,
	mutations,
	actions,
	getters,
} from './store';

import PageBar from '@/components/page-bar/page-bar';

export default {
	name: 'sample',
	state,
	mutations,
	actions,
	getters,
	props: {
		// TODO
	},
	data: () => ({
		dtOption: 'something'
	}),
	computed: {
		...mapGetters([
			// TODO
		]),
		...mapState([
			// TODO
		])
	},
	components: {
		PageBar
	},
	watch: {
		// TODO
	},
	methods: {
		...mapActions([
			'setBreadcrumb',
			// TODO
		])
	},
	beforeCreate() {
		// TODO
	},
	created() {
		// TODO
	},
	beforeMount() {
		// TODO
	},
	mounted() {

		this.setBreadcrumb([{
			text: 'Sample'
		}, {
			text: 'A'
		}, {
			text: 'B'
		}, {
			text: 'C'
		}]);

		// TODO
	},
	beforeUpdate() {
		// TODO
	},
	updated() {
		// TODO
	},
	beforeDestroy() {
		// TODO
	},
	destroyed() {
		// TODO
	}
};



// WEBPACK FOOTER //
// ./sources/app/sample/index.js